import { useEffect, useState } from "react";
import { CssBaseline, IconButton, Paper } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Lock as LockIcon } from "@mui/icons-material"
import { Box, Container } from "@mui/system";
import { useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { getAll } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { ActionFabButtonAdd, ActionsDialogPage } from "./ActionsPage";
import { handleSetInstance } from "./routeHelpers";
import LoaderTable from "components/Loaders/LoaderTable";
import MUIDataTable from "mui-datatables";
import { MUIDataTableGlobalOptions } from "helpers";

export default function User() {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false)
  const [dataFilter, setDataFilter] = useState(null)
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete, 4: permissions
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [instanceSelected, setInstanceSelected] = useState({})
  const [rolesList, setRolesList] = useState([])
  const [branchOfficesList, setBranchOfficesList] = useState([])
  const [permissionsList, setPermissionsList] = useState([])
  const queryClient = useQueryClient()
  const { data } = useQuery('usersList', getAll, { refetchOnWindowFocus: false })

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") {
      let roles = data.roles.map((r) => { return { value: r._id, label: r.name, } })
      let branch_offices = data.branch_offices.map((r) => { return { value: r._id, label: r.name, } })
      setDataFilter(data.users)
      setRolesList(roles)
      setBranchOfficesList(branch_offices)
      setPermissionsList(data.permissions)
      setTimeout(() => { setShowTable(true) }, 1000 )
    }
  }, [data])

  const handleRefreshData = () => { queryClient.invalidateQueries('usersList') }
  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); handleRefreshData() }
  }

  const Actions = ({ id }) => {
    return (<div>
      <IconButton onClick={() => { handleSetInstance(id, data, setInstanceSelected); setOpenAction(2) }} ><EditIcon color="info" /></IconButton>
      <IconButton onClick={() => { handleSetInstance(id, data, setInstanceSelected);; setOpenAction(4) }} ><LockIcon color="success" /></IconButton>
      <IconButton onClick={() => { handleSetInstance(id, data, setInstanceSelected);; setOpenAction(3) }}><DeleteIcon color="error" /></IconButton>
    </div>)
  }

  const columns = [
    {
      name: "name", label: t('users_table_name_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>
      }
    },
    {
      name: "email", label: t('users_table_email_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>
      }
    },
    {
      name: "role", label: t('users_table_role_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>,
        customBodyRender: (value, tableMeta, updateValue) => rolesList.find((r) => { return r.value === value }).label
      }
    },
    {
      name: "_id", label: t('users_table_actions_column'),
      options: {
        filter: false, sort: false, download: false,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Actions id={value} />
          )
        }
      }
    },
  ];

  return (<>
    <FMPageOpacityTransition>
      <CssBaseline />
      <Box component="main" style={{ marginBottom: 100 }}>
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          {(showTable && dataFilter !== null) ?
            <MUIDataTable data={dataFilter} columns={columns} options={MUIDataTableGlobalOptions(t)} /> 
            : <Paper sx={{ padding: 3 }}> <LoaderTable /> </Paper>
          }
        </Container>
      </Box>
      <ActionFabButtonAdd t={t} action={() => setOpenAction(1)} />
      <ActionsDialogPage
        open={openAction}
        close={() => handleResetActions()}
        instance={instanceSelected}
        reportAction={handleWatchAction}
        extraData={{ rolesList, branchOfficesList, permissionsList }} />
    </FMPageOpacityTransition>
    <SnackbarGlobal open={notification.open} close={() => setNotification({ open: false, message: "", severity: "" })} message={notification.message} severity={notification.severity} />
  </>)
}